import Container from "../ui/container";
import LongText from "../ui/LongText";
import styles from "./v2Home_2.module.css";
import { motion } from "framer-motion";
import Assest1 from "../../assets/images/v2_home_2/2x/Asset 1.png";
import Assest2 from "../../assets/images/v2_home_2/2x/Asset 2.png";
import Assest3 from "../../assets/images/v2_home_2/2x/Asset 3.png";
import Assest4 from "../../assets/images/v2_home_2/2x/Asset 4.png";
import Assest5 from "../../assets/images/v2_home_2/2x/Asset 5.png";
import Assest6 from "../../assets/images/v2_home_2/2x/Asset 6.png";
import Assest7 from "../../assets/images/v2_home_2/2x/Asset 7.png";
import Logo from "../../assets/images/v2_home_2/5logo4x.png";
import { useTranslation } from "../../context/LanguageContext";

function V2Home2() {
  const { translate } = useTranslation();

  return (
    <section className={`${styles.background} bg-[#faf1af]`}>
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      <div className="w-full max-w-[1920px] relative mx-auto">
        <motion.div
          className={styles.Assest1}
          initial={{ opacity: 0, x: -10, scale: 0.5 }}
          transition={{ duration: 0.5 }}
          whileInView={{ opacity: 1, x: 0, scale: 1 }}
          viewport={{ once: true }}
        >
          <img src={Assest1} alt="Assest1" width={75} height={70} />
        </motion.div>

        <motion.div
          className={styles.Assest2}
          initial={{ opacity: 0, y: -40, scale: 0.5 }}
          transition={{ duration: 0.5 }}
          whileInView={{ opacity: 1, y: 0, scale: 1 }}
          viewport={{ once: true }}
        >
          <img src={Assest2} alt="Assest2" width={174} height={174} />
        </motion.div>
        <motion.div
          className={styles.Assest3}
          initial={{ opacity: 0, scale: 0.5 }}
          transition={{ duration: 0.5 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
        >
          <img src={Assest3} alt="Assest3" width={116} height={110} />
        </motion.div>
        <motion.div
          className={styles.Assest4}
          initial={{ opacity: 0, scale: 0.5 }}
          transition={{ duration: 0.5 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
        >
          <img src={Assest4} alt="Assest4" width={72} height={97} />
        </motion.div>

        <motion.div
          className={styles.Assest5}
          initial={{ opacity: 0, scale: 0.5 }}
          transition={{ duration: 0.5 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
        >
          <img src={Assest5} alt="Assest5" width={47} height={44} />
        </motion.div>
        <motion.div
          className={styles.Assest6}
          initial={{ opacity: 0, scale: 0.5 }}
          transition={{ duration: 0.5 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
        >
          <img src={Assest6} alt="Assest6" width={57} height={55} />
        </motion.div>
        <motion.div
          className={styles.Assest7}
          initial={{ opacity: 0, scale: 0.5 }}
          transition={{ duration: 0.5 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
        >
          <img src={Assest7} alt="Assest7" width={325} height={176} />
        </motion.div>
        {/*  */}
        {/*  */}
        {/*  */}
        {/*  */}
        {/*  */}
        {/*  */}
        <Container>
          <div className="w-[1380px] mx-auto flex flex-col justify-center items-center text-center relative -z-10">
            <motion.h2
              initial={{ opacity: 0, y: -40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true, amount: 0.8 }}
              className="whitespace-pre-line text-[68px] leading-[1.2] font-bold text-[#686868] font-bricolage"
            >
              {translate("v2Home_2.heading")}
            </motion.h2>

            <div className="justify-center ">
              <img src={Logo} alt="3 logo" />
            </div>
            <motion.div
              initial={{ opacity: 0, y: -40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true, amount: 0.8 }}
            >
              <LongText
                text={translate("v2Home_2.description")}
                className="whitespace-pre-line text-[32px] font-bricolage text-[#3F3F3F] leading-[1.2]"
              />
            </motion.div>
          </div>
        </Container>
      </div>
    </section>
  );
}

export default V2Home2;
